import { defineComponent as _defineComponent } from 'vue'
import {
  ref,
  computed,
  onMounted,
  watch,
  onBeforeUnmount,
  withDefaults,
  nextTick,
} from 'vue';
import { TUIVideoStreamType } from '@tencentcloud/tuiroom-engine-js';
import { StreamInfo, useRoomStore } from '../../../../stores/room';
import { roomService } from '../../../../services/roomService';
import { useBasicStore } from '../../../../stores/basic';
import { storeToRefs } from 'pinia';
import { getNanoId } from '../../../../utils/utils';

interface Props {
  streamInfo: StreamInfo;
  isEnlarge: boolean;
  isNeedPlayStream?: boolean;
  observerViewInVisible?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    streamInfo: null,
    isEnlarge: { type: Boolean },
    isNeedPlayStream: { type: Boolean, default: true },
    observerViewInVisible: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { streamInfo: StreamInfo, isEnlarge: boolean, isNeedPlayStream: boolean, observerViewInVisible?: boolean };

const mediaManager = roomService.getMediaManager();
const basicStore = useBasicStore();
const roomStore = useRoomStore();

const { defaultStreamType, streamInfoObj } = storeToRefs(roomStore);



const playRegionDomRef = ref();
const nanoId = getNanoId(5);
const playRegionDomId = computed(
  () => `${props.streamInfo.userId}_${props.streamInfo.streamType}_${nanoId}`
);

// The stream type to be pulled from the remote user
const streamTypeToFetch = computed(() => {
  const { streamType, userId } = props.streamInfo;
  const { userId: localUserId } = basicStore;
  if (streamType === TUIVideoStreamType.kScreenStream) {
    return TUIVideoStreamType.kScreenStream;
  }
  if (props.isEnlarge || userId === localUserId) {
    return TUIVideoStreamType.kCameraStream;
  }
  return defaultStreamType.value;
});

async function startPlayVideo() {
  if (
    !streamInfoObj.value[
      `${props.streamInfo.userId}_${props.streamInfo.streamType}`
    ] ||
    !playRegionDomRef.value
  ) {
    return;
  }
  await nextTick();
  if (props.isNeedPlayStream && props.streamInfo.hasVideoStream) {
    await mediaManager.startPlayVideo({
      userId: props.streamInfo.userId,
      streamType: streamTypeToFetch.value,
      view: playRegionDomRef.value,
      observerViewInVisible: props.observerViewInVisible,
    });
  }
}

async function stopPlayVideo() {
  await mediaManager.stopPlayVideo({
    userId: props.streamInfo.userId,
    streamType: streamTypeToFetch.value,
    view: playRegionDomRef.value,
  });
}

watch(
  () => [
    props.streamInfo.userId,
    props.streamInfo.streamType,
    props.streamInfo.hasVideoStream,
    props.isNeedPlayStream,
  ],
  async (val, oldVal) => {
    const [oldUserId, oldStreamType] = oldVal;
    if (
      oldUserId !== props.streamInfo.userId ||
      oldStreamType !== props.streamInfo.streamType
    ) {
      // Stops play of the previous stream of the current dom
      mediaManager.stopPlayVideo({
        userId: oldUserId as string,
        streamType: oldStreamType as TUIVideoStreamType,
        view: playRegionDomRef.value,
      });
    }
    if (props.isNeedPlayStream && props.streamInfo.hasVideoStream) {
      await startPlayVideo();
    } else {
      await stopPlayVideo();
    }
  }
);

watch(
  () => streamTypeToFetch,
  async () => {
    if (props.isNeedPlayStream && props.streamInfo.hasVideoStream) {
      await startPlayVideo();
    }
  }
);

onMounted(async () => {
  if (props.isNeedPlayStream && props.streamInfo.hasVideoStream) {
    await startPlayVideo();
  }
});

onBeforeUnmount(async () => {
  if (props.isNeedPlayStream && props.streamInfo.hasVideoStream) {
    await stopPlayVideo();
  }
});

return { __sfc: true,mediaManager, basicStore, roomStore, defaultStreamType, streamInfoObj, props, playRegionDomRef, nanoId, playRegionDomId, streamTypeToFetch, startPlayVideo, stopPlayVideo }
}

})